import { SHIFT_RATE_LABELS } from '../../../../api/shiftPayRates';
import { EM_DASH, formatShiftDate } from '../payFormat';
import type { PayShiftEntry } from '../teacherApi';

import ShiftAmount from './ShiftAmount';

// Widened so a rateKey this build doesn't know yet falls back to the raw key.
const RATE_LABELS: Record<string, string> = SHIFT_RATE_LABELS;

export default function ShiftRow({
  shift,
  salaried = false,
}: {
  shift: PayShiftEntry;
  salaried?: boolean;
}) {
  return (
    <tr>
      <td style={{ whiteSpace: 'nowrap' }}>{formatShiftDate(shift)}</td>
      <td>
        <span style={{ fontWeight: 600 }}>{shift.venueName}</span>
        <span style={{ color: 'var(--nb-subtle)' }}> · {shift.workshopTypeName ?? EM_DASH}</span>
      </td>
      <td className="nb-muted">
        {shift.rateKey ? (RATE_LABELS[shift.rateKey] ?? shift.rateKey) : EM_DASH}
      </td>
      <td>
        {shift.worked ? (
          <span style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>Worked</span>
        ) : (
          <span style={{ fontSize: 11, color: 'var(--nb-primary)' }}>Scheduled</span>
        )}
      </td>
      <td className="nb-tabular nb-mono" style={{ textAlign: 'right' }}>
        <ShiftAmount shift={shift} salaried={salaried} />
      </td>
    </tr>
  );
}
